import { RootState } from '../../types';

export const all = (state: RootState) => state.auth.passwordRecovery;
export const loading = (state: RootState) => all(state).loading;
export const error = (state: RootState) => all(state).error;
